import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private authenticationservice = inject(AuthenticationService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // let currentUser = this.authenticationservice.getCurrentUser()
    let currentUser = this.authenticationservice.getUser();
    if (currentUser?.token?.length) {
      return true
    } else {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          state: state.url
        }
      }
      this.router.navigate(["/auth/my-account"], navigationExtras)
      return false;
    }

  }

}
